/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Svc_Agents_BodyInputs */

const en_services_svc_agents_body = /** @type {(inputs: Services_Svc_Agents_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Several agents that hand work to each other, a researcher, a writer, a reviewer, each with its own tools, a spending limit and the points where a person signs off. Built for processes too big for one assistant.`)
};

const lv_services_svc_agents_body = /** @type {(inputs: Services_Svc_Agents_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vairāki aģenti, kas nodod darbu viens otram, pētnieks, autors, recenzents, katram savi rīki, tēriņu limits un vietas, kur apstiprina cilvēks. Procesiem, kas par lielu vienam asistentam.`)
};

/**
* | output |
* | --- |
* | "Several agents that hand work to each other, a researcher, a writer, a reviewer, each with its own tools, a spending limit and the points where a person sign..." |
*
* @param {Services_Svc_Agents_BodyInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_svc_agents_body = /** @type {((inputs?: Services_Svc_Agents_BodyInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Svc_Agents_BodyInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_svc_agents_body(inputs)
	return en_services_svc_agents_body(inputs)
});